import { useState, useEffect, useRef } from "react";
export const useIsIntersecting = ({ elementId, triggerOnce, rootMargin, delay, defaultState = false, }) => {
    const [isIntersecting, setIsIntersecting] = useState(defaultState);
    const ref = useRef(null);
    useEffect(() => {
        const observer = new IntersectionObserver(([entry]) => {
            if (entry !== undefined) {
                setIsIntersecting(entry.isIntersecting);
                if (entry.isIntersecting && triggerOnce)
                    observer.unobserve(entry.target);
            }
        }, { rootMargin: rootMargin });
        // eslint-disable-next-line no-restricted-globals
        const element = document === null || document === void 0 ? void 0 : document.querySelector(`#${elementId}`);
        const milliSeconds = delay ? delay : 0;
        const timer = setTimeout(() => {
            if (element) {
                observer.observe(element);
                ref.current = element;
            }
        }, milliSeconds);
        return () => {
            observer.disconnect();
            clearTimeout(timer);
        };
    }, [elementId, triggerOnce, rootMargin, delay]);
    return { isIntersecting, ref };
};
